
<div class="wrapper fadeInDown">
  <div id="formContent">
    
     
<!--  
    <form>
      <input type="text" id="login" class="fadeIn second" name="login" placeholder="login">
      <input type="text" id="password" class="fadeIn third" name="login" placeholder="password">
      <input type="submit" class="fadeIn fourth" value="Log In">
    </form>
 
    <div id="formFooter">
      <a class="underlineHover" href="#">Forgot Password?</a>
    </div> -->





    <form action="your action" (submit)="onFormSubmit($event)">
      <div class="dx-fieldset">
        <div class="dx-fieldset-header"> Credenciales</div>
        <div class="text-danger" *ngIf="errorMessage.length!= 0">Usuario o contraseña no valido</div>
        <div class="dx-field">
          <div class="dx-field-label">Usuario</div>
          <div class="dx-field-value">
            <dx-text-box [(value)]="creds.username"  >
              <dx-validator>
                <dxi-validation-rule type="required" message="Correo requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
        <div class="dx-field">
            <div class="dx-field-label">Contraseña</div>
            <div class="dx-field-value">
                <dx-text-box
                    mode="password"
                    [(value)]="creds.password"
                    >
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Contraseña es requerida"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
        </div>
         
      <div class="dx-fieldset">
        <!-- <dx-validation-summary id="summary"></dx-validation-summary> -->
        <div class="dx-field">
          <a [routerLinkActive]="['active']"[routerLink]="['/recoverypass']" >¿Olvido su contraseña?</a>
          <!-- //recover password -->
        </div>
        <!-- <dx-button 
            id="button"
            text="Register"
            type="success"  
            [useSubmitBehavior]="true">
        </dx-button> -->
    </div>
        <div class="dx-fieldset">
            <!-- <dx-validation-summary id="summary"></dx-validation-summary> -->
    
            <dx-button 
                id="button"
                text="Entrar"
                type="success"  
                [useSubmitBehavior]="true">
            </dx-button>
        </div>
    </div> 
  </form>


  </div>
</div>


 
 
 
 
 <!-- 
 <div class="container text-center">
   <div class="col-lg-12">
     <br/>
     <h3>Iniciar sesión</h3>
       <div class="row">
           <div class="col-md-6 offset-md-3">
             <form method="post">
               <div asp-validation-summary="ModelOnly"></div>
               <div class="form-group">
                 <label for="username">Correo</label>
                 <input name="username" class="form-control" />
                 
               </div>
               <div class="form-group">
                 <label for="password">Contraseña</label>
                 <input id="password" type="password" class="form-control" />
               </div>
               <div class="form-group">
                 <input type="submit" value="Login" class="btn btn-success" />
               </div>
             </form>
           </div>
         </div>
   </div>
 </div> -->